import React from "react";
import { CsI18n } from "../../shared/csI18n/csI18n";
import { Card, FormLayout, Layout, TextField } from "@shopify/polaris";
import { CsValidation as V, CsValidationForm } from "../../shared/csValidationForm";

const CompanyMediation = ({ validatorClass, mediationServiceName, mediationUrl, handleChange }) => {
  return (
    <Layout.AnnotatedSection title={CsI18n.t('company.annotate.title.mediation')}
                             description={CsI18n.t("company.annotate.desc.mediation")}>
      <Card>
        <Card.Section>
          <CsValidationForm name={validatorClass} realtime={true}>
            <FormLayout>
              <FormLayout.Group>
                <V>
                  <TextField
                    label={CsI18n.t("Name of the service")}
                    value={mediationServiceName}
                    onChange={handleChange('mediationServiceName')} />
                  <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                </V>
                <V>
                  <TextField
                    label={CsI18n.t("URL or contact")}
                    value={mediationUrl}
                    onChange={handleChange('mediationUrl')} />
                  <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                  <V.Item rule="websiteWtProtocol" title={CsI18n.t("Not a valid website.")} />
                </V>
              </FormLayout.Group>
            </FormLayout>
          </CsValidationForm>
        </Card.Section>
      </Card>
    </Layout.AnnotatedSection>
  );
}

export default CompanyMediation;